import { ReactNode, useMemo } from 'react';
import { useRouter } from './RouterContext';

type RouteConfig = {
  path: string;
  element: ReactNode;
};

interface RouterViewProps {
  routes: RouteConfig[];
  fallback?: ReactNode;
}

const matchRoute = (current: string, target: string) => current === target;

export const RouterView: React.FC<RouterViewProps> = ({ routes, fallback = null }) => {
  const { path } = useRouter();

  const match = useMemo(() => routes.find(({ path: routePath }) => matchRoute(path, routePath)), [path, routes]);

  return <>{match ? match.element : fallback}</>;
};
